// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODIFIED DATA : 07-12-2025

import BranchProfileReportActionTypes from './branch-profile-report.types';

/** ***************** GET BRANCH PROFILE REPORT START *********************** */
export const getBranchProfileReportStart = (getData: any) => ({
	type: BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_START,
	payload: getData,
});

export const getBranchProfileReportSuccess = (successData: any) => ({
	type: BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_SUCCESS,
	payload: successData,
});

export const getBranchProfileReportFailure = (failureData: any) => ({
	type: BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_FAILURE,
	payload: failureData,
});

export const getBranchProfileReportResponseResetStart = () => ({
	type: BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_RESPONSE_RESET,
});

export const getBranchProfileReportResponseChanged = () => ({
	type: BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH PROFILE REPORT END *********************** */
